import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import LogoutModel from './LogoutModel';
import { fncGetAllComments, fncAddComment } from '../Utility/ApiCall.js';
import { shortcutKeyForPage, shortcutKeys } from '../Utility/CommonFun.js';
import { bookingCommentsCredentials } from '../ReduxState';
function Comments({ handleSideMenu,openSideMenu }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const [triggerModal, settriggerModal] = useState(false);
    const AllComments = useSelector(state => state.sidemenu.CommentsForCurrentBooking);
    const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
    const redirectTo = useSelector(state => state.sidemenu.redirectionPage);
    const [noData, setNoData] = useState(false);
    const [commentsType, setCommentType] = useState('2');
    const [commentText, setCommentText] = useState('');
    const commentType = {
        0: 'Reservation',
        1: 'Itinerary',
        2: 'Manifest'
    }

    const notify = (e) =>
                toast.error(e, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                });

    useEffect(() => {
        if (!noData && AllComments.length === 0) {
            getComments();
        }
            
    }, [AllComments]);

    useEffect(() => {
        document.addEventListener("keydown", function (event) {
                // console.log('event', event);                   
                if (event.key && shortcutKeys.includes(event.key)) {
                    const path = shortcutKeyForPage(location.pathname,event, SearchedFlightDetails);
                    if (path) {
                        history.push('/' + path);
                    }                             
                }                                         
        });
    });

    useEffect(() => {
        // Define the function that checks for the Escape key
        const handleKeyDown = (event) => {
          if (event.key === "Escape") {
            goBack(); // Close the popup
          }
        };
    
        // Add the event listener when the component mounts
        document.addEventListener("keydown", handleKeyDown);
    
        // Clean up the event listener when the component unmounts
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [redirectTo]);

    useEffect(() => {
                  //  debugger
                   document.addEventListener("keydown", function (event) {  
                     if (event.altKey && (event.key === 'Dead' || event.key === 'e')) {
                       handleSideMenu();
                     }
                   })
                 });

    const getComments = () => {
        fncGetAllComments()
        .then((commentsForBooking) => {
            if (commentsForBooking.status == "401" && commentsForBooking.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    settriggerModal(true);
            }
            else {
                    if (!commentsForBooking.data.isError) {
                        console.log(commentsForBooking.data.comments)
                        if (commentsForBooking.data.comments.length === 0) {
                            setNoData(true);
                        } else {
                            setNoData(false);
                        }
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            dispatch(bookingCommentsCredentials(
                                    {
                                            type: "",
                                            CommentsForCurrentBooking: commentsForBooking.data.comments
                                    }
                            ));
                    }
                    else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            notify(commentsForBooking.data.errorDetail.errorMessage);
                            console.log(commentsForBooking.data.errorDetail);
                    }
                    document.getElementById("showAndHideSpinner").style.display = "none";
            }

        })
        .catch(err => console.log("Axios err: ", err))
    }

    const goBack = () => {
        history.push(redirectTo);
    }

    const addComment = () => {
        if (commentText !== '') {  
            const currentDate = new Date();
            const apiBody = [{
                RecordLocator: SearchedFlightDetails.recordLocator,
                Comments: [
                    {
                        type: commentType[parseInt(commentsType)],
                        text: commentText,
                        createdDate: currentDate
                    }
                ]
            }]
            fncAddComment(apiBody)
            .then(addCommentResponse => {
                if (addCommentResponse.status == "401" && addCommentResponse.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    //     notify(returnVal.statusText);
                    settriggerModal(true);
                } else {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    if (!addCommentResponse.isError) {
                        getComments();
                        setCommentText('');
                        setCommentType('2');
                    }
                    if (addCommentResponse.errors && addCommentResponse.errors.length) {
                        notify(addCommentResponse.title);
                    }
                }
            })
            .catch(err => console.log("Axios err: ", err))
        }
    }

    return (
        <div>
            <LogoutModel trigger={triggerModal}> </LogoutModel>
            <div class="full-container">
        <div class="card-pInfo white comments">
            <div class="comment-heading">
                <div class="passenger-heading">
                    <h4 class="font-xxl mb-3 dark-text">Add Comments <span class="ms-2 font-md regular">{`(${SearchedFlightDetails.recordLocator})`}</span></h4>
                    <div class="form-group comment-search sp-formField align-self-center mb-0">
                        <a aria-label="Close" onClick={goBack} 
                         onKeyDown={(e)=>{
                            if (e.key === "Enter") {
                                goBack();
                   } } } ><i class="fa fa-times OrangeShadow" tabIndex={0}></i></a>
                    </div>
                </div>
            </div>
            <div class="commentForm">
                <div class="row pt-3">
                    <div class="col-12 col-lg-3 mb-3">
                        <div class="form-group form-floating">
                            <select class="form-control focusClass" value={commentsType} onChange={e => setCommentType(e.target.value)}  required="">
                                <option value=""></option>
                                <option selected="" value="2">MANIFEST</option>
                                <option selected="" value="0">RESERVATION</option>
                                <option selected="" value="1">ITINERARY</option>
                            </select>
                            <label class="bold dark-text" for="commentType">COMMENT TYPE</label>
                        </div>
                    </div>
                    <div class="col-12 col-lg-7 mb-3">
                        <div class="form-group form-floating">
                            <input
                            type="text"
                            placeholder="comment"
                            class="form-control focusClass"
                            autocomplete=""
                            name="comment"
                            value={commentText}
                            onChange={e => setCommentText(e.target.value)}
                            />
                            {/* <input type="text" class="form-control" id="comment" placeholder="comment" name="comment" /> */}
                            <label class="bold dark-text" for="comment">COMMENT</label>
                        </div>
                    </div>

                    <div class="col-4 col-lg-2 mb-3 d-flex justify-content-end">
                        <button type="button" class="btn btn-primary btn-animation w-100 mt-2 SerachBtn" onClick={addComment}><span>Submit</span></button>
                    </div>
                </div>
            </div>
            <div class="comments-listing">
                <div class="row pt-2">
                    <div class="col-12 mb-3">
                        <h4 class="font-xxl mb-3 dark-text">Comments </h4>
                    </div>
                </div>
                <div class="comment-list">
                    {
                        AllComments.length > 0 ?
                        AllComments.map((comment) =>
                        <div class="comment-list-item">
                            <div class="comment-list-content">
                                <div class="comment-item-image">
                                    <img src="newImages/comment-image.svg" />
                                </div>
                                <div class="comment-data">
                                    <h5 class="font-sm bold dark-text mb-1">{comment.pointOfSale.agentCode} {`(${commentType[comment.type]})`}</h5>
                                    <p class="font-sm mid-dark-text mb-1">{comment.text}</p>
                                    <p class="font-sm grey-text mb-0">{new Date(comment.createdDate).toGMTString().substring(0, new Date(comment.createdDate).toGMTString().lastIndexOf(":"))}</p>
                                </div>
                            </div>
                            {/* <div class="comment-actions">
                                <a data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#editComment" class="icon-btn" data-bs-toggle="tooltip" data-bs-html="true" title="" data-bs-original-title="Edit" aria-label="Edit"><img src="newImages/icon-edit.svg" /></a>
                                <a class="icon-btn" data-bs-toggle="tooltip" data-bs-html="true" title="" data-bs-original-title="Delete" aria-label="Delete"><img src="newImages/icon-delete.svg" /></a>
                            </div> */}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    </div>

    {/* <!-- modal --> */}
    <div class="modal fade " id="editComment" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" data-bs-backdrop="static" data-dismiss="modal" data-toggle="modal">
        <div class="modal-dialog modal-dialog-centered middle-modal">
            <div class="modal-content">
                <div class="heading">
                    <a data-bs-dismiss="modal" class="modal-close">
                        <img src="newImages/i-cross.svg" alt="cross" />
                    </a>
                    <h4 class="font-xxl bold dark-text mb-0">Edit Comment</h4>
                </div>
                <div class="edit-comment-form mt-4">
                    <div class="row pt-3">
                        <div class="col-12 mb-3">
                            <div class="form-group form-floating">
                                <select class="form-control" id="commentType">
                                    <option>Select</option>
                                    <option selected value="MENIFEST">MENIFEST</option>
                                </select>
                                <label class="bold dark-text" for="commentType">COMMENT TYPE</label>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <div class="form-group form-floating">
                                <textarea rows="3" class="form-control" id="comment" placeholder="comment" name="comment">Dear Mr. Thakur, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</textarea>
                                <label class="bold dark-text" for="comment">COMMENT</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-container mt-4">
                    <button class="btn btn-primary addBags-btn me-4">
                        <span class="px-4">Update</span>
                    </button>
                    <a data-bs-dismiss="modal" class="btn btn-outline-primary">
                        <span class="px-4">Close</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
            {/* <div class="row mx-0 commentList">
                <div class="col-12 mt-4 comment-info rounded sp-tab-content box-white-shadow">
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-6  mb-3">
                            <h4 class="main-heading">
                                Add Comments <span class="comment-code">{`(${SearchedFlightDetails.recordLocator})`}</span>
                            </h4>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 d-flex justify-content-end  mb-3">
                            <div class="form-group comment-search sp-formField align-self-center mb-0">
                            <a aria-label="Close" onClick={goBack} ><i class="fa fa-times"></i></a>
                            </div>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-12 col-lg-3 mb-3">
                            <div class="form-group sp-formField  sp-selected">
                                <select class="form-control" value={commentsType} onChange={e => setCommentType(e.target.value)}  required="">
                                    <option value=""></option>
                                    <option selected="" value="2">MANIFEST</option>
                                    <option selected="" value="0">RESERVATION</option>
                                    <option selected="" value="1">ITINERARY</option>
                                </select>
                                <span class="label">COMMENT TYPE</span>
                            </div>
                        </div>
                        <div class="col-12 col-lg-7 mb-3">
                            <div class="form-group sp-formField">
                                <input
                                type="text"
                                class="form-control"
                                autocomplete=""
                                name="comment"
                                value={commentText}
                                onChange={e => setCommentText(e.target.value)}
                                />
                                <span class="label">COMMENT</span>
                            </div>
                        </div>

                        <div class="col-12 col-lg-2 mb-3">
                            <button
                            type="button"
                            onClick={addComment}
                            class="btn text-nowrap btn-red px-2 d-block w-100 py-2">
                                Submit
                            </button>
                        </div>
                    </div>

                    <div class="row pt-2">
                        <div class="col-12 mb-3">
                            <h4 class="main-heading">
                                Comments
                            </h4>
                        </div>
                    </div>
                    <div class="comment-list">
                        {
                            AllComments.length &&
                            AllComments.map((comment) => 
                        (    <div class="comment-list-item">
                                <div class="comment-item-image">
                                    <img src="./images/comment-image.svg" />
                                </div>
                                <div class="comment-data">
                                    <h5 class="comment-heading">{comment.pointOfSale.agentCode} {`(${commentType[comment.type]})`}</h5>
                                    <p class="comment-text">{comment.text}</p>
                                    <p class="comment-date">{new Date(comment.createdDate).toGMTString().substring(0, new Date(comment.createdDate).toGMTString().lastIndexOf(":"))}</p>
                                </div>
                            </div>
                            ))
                        }     
                    </div>

                </div>
            </div> */}
        </div>
    );
}

export default Comments;